if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.initDekofarLightbox();

      setTimeout(() => {
        this.buildThumbs();
        this.activateMedia(false);
      }, 150);
    }

    hide() {
      super.hide();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    showActiveMedia() {
      const openedId = this.openedBy?.getAttribute('data-media-id');
      const items = this.getMediaItems();

      items.forEach((item, index) => {
        item.classList.remove('active');

        if (item.getAttribute('data-media-id') === openedId) {
          this.currentIndex = index;
        }
      });
    }

    activateMedia(animate = true) {
      const items = this.getMediaItems();
      const active = items[this.currentIndex];
      const container = this.querySelector('[role="document"]');

      if (!active || !container) return;

      items.forEach(item => item.classList.remove('active'));
      active.classList.add('active');

      container.scrollTo({
        left: active.offsetLeft - ((container.clientWidth - active.clientWidth) / 2),
        behavior: animate ? 'smooth' : 'auto'
      });

      this.updateThumbs();
    }

    go(direction) {
      const items = this.getMediaItems();
      if (!items.length) return;

      this.currentIndex =
        direction === 'next'
          ? (this.currentIndex + 1) % items.length
          : (this.currentIndex - 1 + items.length) % items.length;

      this.activateMedia(true);
    }

    initDekofarLightbox() {
      if (this.dataset.dekofarLightboxReady === 'true') return;
      this.dataset.dekofarLightboxReady = 'true';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'dekofar-lightbox-arrow dekofar-lightbox-prev';
      prev.innerHTML = '‹';
      prev.setAttribute('aria-label', 'Önceki görsel');

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'dekofar-lightbox-arrow dekofar-lightbox-next';
      next.innerHTML = '›';
      next.setAttribute('aria-label', 'Sonraki görsel');

      const thumbs = document.createElement('div');
      thumbs.className = 'dekofar-lightbox-thumbs';

      this.appendChild(prev);
      this.appendChild(next);
      this.appendChild(thumbs);

      prev.addEventListener('click', () => this.go('prev'));
      next.addEventListener('click', () => this.go('next'));

      const container = this.querySelector('[role="document"]');

      if (container) {
        container.addEventListener('touchstart', e => {
          this.touchStartX = e.changedTouches[0].clientX;
        }, { passive:true });

        container.addEventListener('touchend', e => {
          this.touchEndX = e.changedTouches[0].clientX;
          this.handleSwipe();
        }, { passive:true });
      }

      document.addEventListener('keydown', e => {
        if (!this.hasAttribute('open')) return;

        if (e.key === 'ArrowRight') {
          this.go('next');
        }

        if (e.key === 'ArrowLeft') {
          this.go('prev');
        }
      });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;

      if (Math.abs(diff) < 45) return;

      if (diff > 0) {
        this.go('next');
      } else {
        this.go('prev');
      }
    }

    buildThumbs() {
      const thumbs = this.querySelector('.dekofar-lightbox-thumbs');
      const items = this.getMediaItems();

      if (!thumbs || !items.length) return;

      thumbs.innerHTML = '';

      items.forEach((item, index) => {
        const mediaId = item.getAttribute('data-media-id');
        let img = item.querySelector('img');

        if (!img && mediaId) {
          const cleanId = mediaId.split('-').pop();

          img =
            document.querySelector(`[data-target="${mediaId}"] img`) ||
            document.querySelector(`#Thumbnail-${cleanId}`) ||
            document.querySelector(`img[id*="${cleanId}"]`) ||
            document.querySelector(`[data-media-id="${mediaId}"] img`);
        }

        if (!img) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dekofar-lightbox-thumb';
        btn.dataset.index = index;
        btn.setAttribute('aria-label', 'Görsel ' + (index + 1));

        const thumbImg = document.createElement('img');
        thumbImg.src = img.currentSrc || img.src;
        thumbImg.alt = img.alt || '';

        btn.appendChild(thumbImg);
        thumbs.appendChild(btn);

        btn.addEventListener('click', () => {
          this.currentIndex = index;
          this.activateMedia(true);
        });
      });

      this.updateThumbs();
    }

    updateThumbs() {
      this.querySelectorAll('.dekofar-lightbox-thumb').forEach((thumb, index) => {
        thumb.classList.toggle('active', index === this.currentIndex);
      });
    }
  });
}